import Modal from "react-bootstrap/Modal";
import Map from "../MapTemplate/Map";
import Button from "../../../atoms/Buttons/Button/Button";
import IconHome from "../../../../styles/icons/IconHome";

interface Location {
  lat: number;
  lng: number;
}

interface Props {
  onHide: () => void;
  show: boolean;
  header: string;
  bodyHeadline: string;
  bodyContent: string;
  name: string;
  origin: Location | null;
  destination: Location | null;
}

const LocationModal = (props: Props) => {
  // Function to handle the click and open Google Maps
  const handleViewOnGoogleMaps = () => {
    if (props.origin && props.destination) {
      const { lat: originLat, lng: originLng } = props.origin;
      const { lat: destinationLat, lng: destinationLng } = props.destination;

      const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${destinationLat},${destinationLng}&destination=${originLat},${originLng}`;
      window.open(googleMapsUrl, "_blank");
    } else {
      alert("Origin or destination coordinates are not available.");
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-modal"
    >
      <Modal.Header closeButton className="header">
        <Modal.Title id="contained-modal-title-vcenter" className="title">
          <IconHome breadcrumb="locationIcon" /> Location Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="body">
        <div>
          <div className="address-label">Primary address location</div>
          <p className="m-0 mb-4">
            {props.name === "Location" ? props.header : props.header}
          </p>
        </div>
        <Map origin={props.destination!} destination={props.origin!} />
      </Modal.Body>
      <Modal.Footer>
        <Button
          text="View on Google Maps"
          onClick={handleViewOnGoogleMaps}
          cssClass="btn-primary"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default LocationModal;
